module.exports = __webpack_public_path__ + "media/src/images/icons/olympinfo/olympinfo-sert-5cad9e406f391a5458a0f860cae39ca1.svg";